import { render } from "./Users.vue?vue&type=template&id=52e758c2&scoped=true"
import script from "./Users.vue?vue&type=script&lang=js"
export * from "./Users.vue?vue&type=script&lang=js"

import "./Users.vue?vue&type=style&index=0&id=52e758c2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-52e758c2"

export default script